import { uploadFileToS3 } from './s3Upload';
import { compressImage } from './imageCompress';

// Same allow-list the backend enforces for uploaded images — used on the
// file-picker's `accept` attribute so the OS dialog can't offer a format
// that would be rejected right after it's chosen.
export const ACCEPT_ATTR = 'image/jpeg,image/png,image/webp,image/gif';

/**
 * Compresses and uploads any number of image files to S3, in parallel.
 * Returns the resulting URLs in the same order the files were given —
 * a failed upload resolves to `null` at that position rather than
 * rejecting the whole batch, so one bad file doesn't lose the rest.
 *
 * @param {File[]} files
 * @param {string} folder - S3 destination folder (e.g. 'blogs')
 * @returns {Promise<(string|null)[]>}
 */
export async function uploadImages(files, folder = 'blogs') {
  return Promise.all(
    files.map(async (file) => {
      try {
        const compressed = await compressImage(file, 300);
        return await uploadFileToS3(compressed, folder);
      } catch (err) {
        console.error('Image upload failed:', file.name, err);
        return null;
      }
    })
  );
}
